import { Button } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(7),
  fontFamily: 'montserrat',
  marginTop: -50,
  fontSize: '12px',
}));

export const LoadingStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  height: '80%',
  position: 'fixed',
});

export const ReleasesStyled = styled('div')(({ theme }) => ({
  height: 100,
  margin: '18px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '33px 19px',
  '& .ticket': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
    border: `1px dashed ${theme.palette.global.lightgray}`,
    height: 42,
    '&:hover': {
      backgroundColor: alpha(theme.palette.global.lightgray, 0.08),
      cursor: 'pointer',
    },
  },
}));

export const DragFilesStyled = styled(Button)({
  width: 640,
  height: 42,
  borderRadius: 5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
